import React from 'react';
import { useLocation , useNavigate } from 'react-router-dom';


const Mes: React.FC = () => {
	const location = useLocation();
	const navigate = useNavigate();

	let message = location.state.message;
	message = message.replace('LOGIN.EMAIL_SENT_RECENTLY',
			'先ほど、既にそのアドレスに確認コードをお送りしました。別のアドレスを入力するか、時間をおいてからお試しください。');
	message = message.replace('LOGIN.EMAIL_CODE_NOT_VALID',
			'入力いただいた確認コードは誤りです。再度、入力してください。');
	message = message.replace('REGISTRATION.USER_ALREADY_REGISTERED',
			'そのアドレスでは既に登録されています。');

    	const clickBack = () => {
        	navigate(-1);
    	};

  return (
    <div>
      <h1>すみませんがエラーです</h1>
      <p>{message}</p>
      <br/>
      <button onClick={clickBack}>戻る</button>
    </div>
  );
};

export default Mes;
